import type { User } from "@/types";

/**
 * Whether the profile step still has work to do.
 *
 * Not `!displayName`. A social sign-in hands us a display name from the
 * provider, so that test called the step finished for anyone arriving through
 * Google and dropped them on the permissions screen with their headline, date
 * of birth and friendship goals never asked for. The step is done when the
 * things it collects are actually there.
 */
export function needsProfileSetup(user: User | null | undefined): boolean {
  return (
    !user?.displayName?.trim() ||
    !user?.headline?.trim() ||
    !user?.dateOfBirth ||
    !user?.lookingFor?.length
  );
}
